import {field, EntityData, collection} from "./entity.data";

/**
 * Defines a localisable context for a LocalisableEntityData.
 */
export class LocalisableContextData extends EntityData<LocalisableContextData> {
    private _universal: boolean;
    private _outlets: number[];
    private _customObjects: number[];
    private _accessibleOutlets: number[];
    private _restricted: boolean;

    @field get restricted(): boolean {
        return this._restricted;
    }

    set restricted(value: boolean) {
        this._restricted = value;
    }

    @collection() get accessibleOutlets(): number[] {
        return this._accessibleOutlets;
    }

    set accessibleOutlets(value: number[]) {
        this._accessibleOutlets = value;
    }

    @collection() get customObjects(): number[] {
        return this._customObjects;
    }

    set customObjects(value: number[]) {
        this._customObjects = value;
    }

    @collection() get outlets(): number[] {
        return this._outlets;
    }

    set outlets(value: number[]) {
        this._outlets = value;
    }

    @field get universal(): boolean {
        return this._universal;
    }

    set universal(value: boolean) {
        this._universal = value;
    }
}
